import React, { useContext } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { DialogHeader } from "../../../auth/components/DialogHeader";
import DangerBaseButton from "../../../main/components/DangerBaseButton";
import BaseButton from "../../../main/components/BaseButton";
import { MainContext } from "../../../main/context/MainContextProvider";

type ConfirmationDialogProps = {
  open: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  onClose: () => void;
};

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  onClose,
}) => {
  const { theme } = useContext(MainContext);
  const primary = theme.muiTheme.palette.primary.main;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
    >
      <DialogHeader id="customized-dialog-title" onClose={onClose}>
        {title}
      </DialogHeader>
      <DialogContent
        sx={{
          width: "450px",
          height: "120px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
        dividers
      >
        <Typography gutterBottom sx={{ fontSize: "18px" }}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions>
        <DangerBaseButton onClick={onCancel} title="Cancelar" />
        <BaseButton
          sx={{
            backGroundColor: primary,
            borderColor: primary,
            height: "34px",
            width: "95px",
            "& .MuiTypography-root": {
              color: primary,
            },
            "&:hover": {
              borderColor: primary,
              backgroundColor: primary,
              color: primary,
              "& .MuiTypography-root": {
                color: "#FFFFFF",
              },
            },
          }}
          onClick={onConfirm}
          title="Confirmar"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
